// @flow
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '../handle-reduce';
import { SAVE_GROUP_PENDING, SAVE_GROUP_COMPLETE, SAVE_NEW_GROUP_COMPLETE } from './constants';

const defaultState = fromJS({
    saving: false
});

const reducers = {
    // $FlowFixMe
    [SAVE_GROUP_PENDING]: handleReduce(state => state.set('saving', true)),
    // $FlowFixMe
    [SAVE_GROUP_COMPLETE]: handleReduce(state => state.set('saving', false)),
    // $FlowFixMe
    [SAVE_NEW_GROUP_COMPLETE]: handleReduce(state => state.set('saving', false))
};

export default handleActions(reducers, defaultState);



// WEBPACK FOOTER //
// ./src/core/state/groups/index.js